export default function Skills(){
    return (
        <div> 
            
        </div>
    );
}